import { size, each, head, tail, } from 'lodash';
import { E_PackageTag } from '../apis/service/PackageApi.types';
export function splitPackages(packages) {
    let mainPackages = [];
    let subPackages = [];
    if (size(packages) === 0) {
        return {
            mainPackages,
            subPackages,
        };
    }
    let findit = false;
    each(packages, pkg => {
        // 优先Base   E_PackageTag.BASE  是一个枚举  值为BASE
        if (pkg.package_tag === 'BASE' && !findit) {
            findit = true;
            mainPackages.push(pkg);
        }
        else {
            subPackages.push(pkg);
        }
    });
    if (findit) {
        return {
            mainPackages,
            subPackages,
        };
    }
    mainPackages = [];
    subPackages = [];
    each(packages, pkg => {
        // 再次 SUB_INDEPENDENT , E_PackageTag.SUB_INDEPENDENT 是一个枚举
        if (pkg.package_tag === E_PackageTag.SUB_INDEPENDENT && !findit) {
            findit = true;
            mainPackages.push(pkg);
        }
        else {
            subPackages.push(pkg);
        }
    });
    if (findit) {
        return {
            mainPackages,
            subPackages,
        };
    }
    // 没有base 没有 SUB_INDEPENDENT
    // console.warn('Invalidate packages:', packages)
    mainPackages = [head(packages)]; // 直接切割
    subPackages = tail(packages);
    return {
        mainPackages,
        subPackages,
    };
}
